import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCut } from '@fortawesome/free-solid-svg-icons'

/**
 * A decorative, dataless block that forces the following content onto a new page in PDF /
 * document exports. On screen it renders as a labeled dashed divider so authors can see where
 * the break sits; it has no configuration of its own.
 */
const PageBreakChart = () => (
  <div
    className="d-flex align-items-center text-muted small text-uppercase"
    style={{ gap: '0.75rem', letterSpacing: '1px' }}
    aria-label="Page break"
  >
    <span style={{ flex: 1, borderTop: '2px dotted #adb5bd' }} />
    <span className="d-flex align-items-center" style={{ flexShrink: 0, gap: '0.4rem' }}>
      <FontAwesomeIcon icon={faCut} />
      Page Break
    </span>
    <span style={{ flex: 1, borderTop: '2px dotted #adb5bd' }} />
  </div>
)

// ---------------------------------------------------------------------------
// Chart registry configuration
// ---------------------------------------------------------------------------
export const pageBreakChartConfig = {
  requiredFields: [],

  validate: () => ({}),

  isQueryEnabled: () => false,

  buildChartParams: () => ({}),

  buildQueryParams: (baseParams) => baseParams,

  renderOptions: () => null
}

export default PageBreakChart
